import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme=>({
    colorComponente:{
        backgroundColor: 'white',
        alignItems: "center",
        flexFlow: "row-wrap",
        border: '1px solid  #cccccc ',
        borderRadius: '20px',                
        position: "relative",
        width: "100%",
        overflow: "auto",
        paddingLeft: '0px',
        paddingRight: '0px',
    },

    root: {
        backgroundColor: 'white',
        paddingLeft: '50px',
        paddingRight: '50px',       
        paddingBottom: '65px' 
        // paddingLeft: '30px',
        // paddingRight: '30px',
    },
	description: {
        margin: '10px 0px',
        textAlign: 'center',
	},    
	buttons: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},    
    marginBoton:{
        paddingBottom: '10px',
    },
    marginAlert:{
        margin: '0px 150px',
    },

    marginText:{
        paddingLeft: '10px',
        display: 'contents'
    },

    rootLista: {
        width: '100%',
        maxWidth: '100%',
    },

    rootListItem: {
        paddingBottom: '4px',
        paddingTop: '0px',
    },
    colorIcon:{
        color: 'black',
    },

    colorChip:{
        backgroundColor: '#1C4E78',
        color:'white'
    },
    AlignTable:{     
        textAlign: 'center',
    },
    AlignAlerta:{     
        textAlign: 'center',
        padding: '10px',
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
      },    
    lineaDegradadaBottom:{
        position: "relative",
        bottom: 0,
        left: 0,
        width: "100%",
        height: 4,
        background: `linear-gradient(344deg, rgba(2,0,36,1) 0%, rgba(9,9,121,1) 35%, rgba(0,212,255,1) 100%)`,
    },
}))